import { useEffect, useState } from "react";

import { type Environment, getEnvironment, subscribeToEnvironment } from "../api/client";

/**
 * Returns the currently-active environment and re-renders whenever
 * setEnvironment() is called (via the subscriber pattern in client.ts).
 */
export function useEnvironment(): Environment {
  const [env, setEnv] = useState<Environment>(getEnvironment);

  useEffect(() => {
    return subscribeToEnvironment(() => {
      setEnv(getEnvironment());
    });
  }, []);

  return env;
}
